import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CatalogoService {
  path: string = '../../../assets/image/vdi/IMG/';
  pathFabrimedic: string = '../../../assets/image/estados/';
  constructor() { }

  catalogoTipoLectura() {
    return [
      { clave: '1', valor: 'Tarjeta' },
      { clave: '2', valor: 'Cédula' }
    ];
  }

  rolesDotacion() {
    return {
        DOTACIONADMIN: "DOTACION-ADMIN",
        DOTACIONENTREGA: "DOTACION-ENTREGA"
      }
  }

  authDotacion() {
    return {
        ROLEADMINDOTACION: "ROLE_ADMIN_DOTACION",
        ROLEPUNTOENTREGADOTACION: "ROLE_PUNTO_ENTREGA_DOTACION"
      }
  }

  catalogoTipo() {
    return [
      {clave:'Principal', valor: 'Principal'},
      {clave:'General', valor: 'General'}
    ]
  }

  catalogoBanderaUser(){
    return {
      Principal: "Principal",
      General: "General"
    }
  }

  catalogoAccesoIESS() {
    return [
      {clave: 'Activo' , valor: 'Activo' },
      {clave: 'Inactivo' , valor: 'Inactivo' }
    ];
  }

  getCodEmpreFabril() {
    return {
      codEmpresa: "FABR",
      descripcion: "LA FABRIL S.A.",
      grupoFabril: 1
    };
  }

  catalogoAsesorIcon() {
    return {
      vendedor: this.path + 'aser.jpg',
      vendeorApoyo: this.path + 'user.png',
      cliente: this.path + 'client.png',
      fechaCalendario: this.path + 'calendario-semanal.png',
      refineria: this.path + 'iconRefineria.png',
      planta: this.path + 'iconPlanta.png',
      calendario: this.path + 'calendario.png',
      paradaTvc: this.path + 'paradaTvc.png',
      csv: this.path + 'csv.svg',
    };
  }
  // "tipo": "Principal"         o    "tipo": "General"
//   respuesta: [{authorityName: "ROLE_ADMIN_DOTACION", userId: 62},…]
// 0: {authorityName: "ROLE_ADMIN_DOTACION", userId: 62}
// 1: {authorityName: "ROLE_PUNTO_ENTREGA_DOTACION", userId: 62}
// 2: {authorityName: "ROLE_USER", userId: 62}
  
}
